export default __webpack_public_path__ + "static/media/female-dr.5daed170.png";